import { render, staticRenderFns } from "./project-relation-info.vue?vue&type=template&id=3121cf78&scoped=true"
import script from "./project-relation-info.vue?vue&type=script&lang=js"
export * from "./project-relation-info.vue?vue&type=script&lang=js"
import style0 from "./project-relation-info.vue?vue&type=style&index=0&id=3121cf78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121cf78",
  null
  
)

export default component.exports